import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthPage } from '@/pages/Auth';
import { LocalStorageKeys } from '@/app/localStorage/types.ts';

export const Route = createFileRoute('/_layout/auth/')({
  component: AuthPage,
  beforeLoad: async ({ preload }) => {
    if (preload) {
      return;
    }

    const token = localStorage.getItem(LocalStorageKeys.Token);
    if (token) {
      throw redirect({
        to: '/',
      });
    }
  },
});
